import { Step } from '../components/steps/Step';
import { OnboardingFlows } from './common';

export const hearAboutUs: Step = {
    id: OnboardingFlows.NewChannel,
    title: 'How did you hear about us?',
    multiSelect: false,
    randomize: true,
    options: [
        {
            label: 'Word of mouth',
        },
        {
            label: 'LinkedIn',
        },
        {
            label: 'Instagram',
        },
        {
            label: 'Youtube',
        },
        {
            label: 'News Article / Online Article',
        },
        {
            label: 'Search Engine (Google, Bing, Yahoo)',
        },
        {
            label: 'Facebook',
        },
        {
            label: 'TikTok',
        },
        {
            label: 'D-ID blog',
        },
        {
            label: 'G2',
        },
        {
            label: 'ChatGPT, Gemini, or other LLM',
        },
        {
            label: 'Other',
            id: 'onboard_new_channel_other',
        },
    ],
};
